export default {
      id: "logo-usage",
      viewBox: "0 0 118 24",
      url: __webpack_public_path__ + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }